/***
 * Created on 2023/10/2
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPut} from "../../../service/api";


function BetaProgramDialog({join, app_id, ...props}) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const joinMutation = useMutation({
        mutationFn: async (data) => await apiPut(`/ajax/user/app/${app_id}/beta_program`, data),
        onSuccess: data => {
            queryClient.invalidateQueries({
                queryKey: ['userApplications']
            });
            props.closeModal();
        },
        onError: (error, variables, context) => {}
    });

    const onSubmit = async () => {
        await joinMutation.mutateAsync({join});
    }

    return (
        <ModalDialog {...props}
                     title={join ? t('@Become a beta tester@') : t('@Leave beta program@')}
                     submitText={join ? t('@Join beta@') : t('@Leave beta@')}
                     submitAction={onSubmit}>
            <div className="dialog-content">
                {join && <p>{t('@Try our new features before they are officially released. Provide your feedback to QNAP. You can leave the beta test at any time.@')}</p>}
                {!join && <p>{t('@If you leave the testing program, you will no longer experience the beta features. Are you sure you want to leave the beta program?@')}</p>}
            </div>
        </ModalDialog>
    );
}

export default BetaProgramDialog;